module.exports = __webpack_public_path__ + "ed88d2bb5c0a033a55573f56474e1f5b.svg";